// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"582a464a","284":"5f405c74","448":"48a1958c","456":"05585acf","472":"f3ff5c38","520":"41a87e62","664":"48a1958c","792":"161fd258"}[chunkId] + ".chunk.css";
};